import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import Swal from "sweetalert2";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { EditDeleteActionsRenderer } from '../../shared/ag-grid/cell-renderers/edit-delete.component';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { AppCoreService } from "src/app/services/app-core.service";
import { NetworkService } from "src/app/services/network.service";
import { MobileNumberValidation, PANValidation } from 'src/app/models/validator';
import { AssetsService } from "src/app/services/assets/assets.service";
import { Utilities } from "src/app/models/utilities";
import { Title } from "@angular/platform-browser";
@Component({
  selector: 'app-assets',
  templateUrl: './assets.component.html',
  styleUrls: ['./assets.component.scss']
})
export class AssetsComponent implements OnInit, AfterViewInit {
  @ViewChild('vehicleCode') vehicleCode!: ElementRef;
  @ViewChild('driverName') driverName!: ElementRef;
  @ViewChild('ownerName') ownerName!: ElementRef;

  assetForm: FormGroup;
  vehicleForm: FormGroup;
  driverForm: FormGroup;
  vehicleOwnerForm: FormGroup;
  combinedData: any = {};
  isFormSubmitted: boolean;
  formSubmitted: boolean;
  isVehicle = true;
  isDriver = false;
  isVehicleOwner = false;
  isUpdate = false;
  isActiveTab = 1;
  editCellId: number;
  currentDate: any;

  serviceCenterList: any[] = [];
  assetTypeList: any[] = [{ name: 'Owner', value: 'owner' }, { name: 'Vehicle', value: 'vehicle' }, { name: 'Driver', value: 'driver' },];
  isAssetsTabActive = true;
  ownerList: [];
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;
  defaultColDef = {
    sortable: true
  };
  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 10,
    domLayout: 'autoHeight'
  }
  columnVehicleDefs = [
    { headerName: 'Type', field: 'vehicletype' },
    { headerName: 'Vehicle Code', field: 'code' },
    { headerName: 'Service Center', field: 'servicecenter' },
    {
      headerName: 'Status',
      field: 'status',
      cellRenderer: (params: { value: boolean; }) => {
        let statusHtml = params.value == true ? `<span class="badge bg-success">Yes</span>` : `<span class="badge bg-primary">No</span>`;
        return statusHtml;
      }
    },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: EditDeleteActionsRenderer,
      colId: 'params',
      editable: false
    }
  ];

  columnOwnerDefs = [
    { headerName: 'Name', field: 'name', filter: true },
    { headerName: 'Address1', field: 'address1', filter: true },
    { headerName: 'Address2', field: 'address2', filter: true },
    { headerName: 'Mobile No.', field: 'phoneno', filter: true },
    { headerName: 'Pan No.', field: 'pannumber', filter: true },
    {
      headerName: 'Actions',
      field: 'id',
      // cellRendererParams: { context: this },
      cellRenderer: EditDeleteActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      sortable: false,
      minWidth: 150,
    },
  ];

  columnDriverDefs = [
    { headerName: 'Name', field: 'name', filter: true },
    { headerName: 'Address1', field: 'address1', filter: true },
    { headerName: 'Address2', field: 'address2', filter: true },
    { headerName: 'Phone No.', field: 'phoneno', filter: true },
    { headerName: 'Licence No.', field: 'licenceno', filter: true },
    { headerName: 'Issued By', field: 'issuedby', filter: true },
    {
      headerName: 'Issue Date',
      field: 'issueddate',
      cellRenderer: (params: { value: any }) => {
        if(params?.value){
          const { dateString } = this.formateDate(params.value);
          return dateString;
        }
      },
      filter: true
    },
    {
      headerName: 'Valid Upto',
      field: 'validupto',
      cellRenderer: (params: { value: any }) => {
        if(params?.value){
          const { dateString } = this.formateDate(params.value);
          return dateString;
        }
      },
      filter: true
    },
    {
      headerName: 'Actions',
      field: 'id',
      // cellRendererParams: { context: this },
      cellRenderer: EditDeleteActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      sortable: false,
      minWidth: 150,
    },
  ];

  selectedSCId: any;
  vehicleRowData = [];
  driverRowData = [];
  ownerRowData = [];
  typeList: any[] = [];
  useEnterKey: any;

  constructor(
    private formBuilder: FormBuilder,
    private assetsService: AssetsService,
    private ngxLoaderService: NgxUiLoaderService,
    private appCoreService: AppCoreService,
    private networkService: NetworkService,
    private utilities: Utilities,
    private titleService: Title
  ) {
    titleService.setTitle('Asset Management');
    this.context = { componentParent: this };
  }

  ngOnInit(): void {
    this.currentDate = this.utilities.FormatDateWithTime();
    this.typeList = ['Bike', 'Auto', 'Tempo', 'Car', 'Truck'];
    this.assetForm = this.formBuilder.group({
      ddlAssetType: ['owner', [Validators.required]],
      ddlServiceCenter: [null, [Validators.required]]

    });
    this.vehicleForm = this.formBuilder.group({
      txtVehicleNumber: [null, [Validators.required]],
      ddlVehicleType: [null, [Validators.required]],
      ddlVehicleOwner: [null, [Validators.required]],
      txtChasisNumber: [null],
      txtEngineNumber: [null],
      txtVehicleCapacity: [null],
      checkBoxStatus: [false]
    });

    this.driverForm = this.formBuilder.group({
      txtDriverName: [null, [Validators.required]],
      txtAddress1: [null],
      txtAddress2: [null],
      txtPhoneNo: [null, MobileNumberValidation],
      txtLicenceNumber: [null],
      txtissuedBy: [null],
      txtIssueDate: [this.currentDate.dateString],
      txtValidUpTo: [this.currentDate.dateString],
    });

    this.vehicleOwnerForm = this.formBuilder.group({
      txtOwnerName: [null, [Validators.required]],
      txtAddress1: [null],
      txtAddress2: [null],
      txtPhoneNo: [null, MobileNumberValidation],
      txtPanNumber: [null, Validators.compose([Validators.required, PANValidation])],
    });

    this.checkPermission();
    this.getServiceCenters();
    this.onAssetsChange();

    if (this.permConfig.isViewAllowed) {
      this.appCoreService.SelectedServiceCenter().subscribe((val) => {
        this.selectedSCId = val;
      });
    }
  }

  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.assetForm) : null;
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    const permission = userData.config.filter(x => x.categoryname === 'AssetManagement');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  async openConfirmationDialog(msg: any,) {
    const res = await Swal.fire({
      // title: 'Success',
      text: msg,
      icon: 'success',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
    if (res.isConfirmed) {
      this.bindAssetsList();
      this.isUpdate = false;
      this.resetForm();
    }
  }

  deleteAction(cell: any) {
    if (!this.permConfig.isDeleteAllowed) {
      this.warningDialog('No access to Delete.');
    }
    else if (this.permConfig.isDeleteAllowed && cell && cell.id) {
      this.deleteConfirmationDialog('Are you sure you want to delete ?', cell.id);
    }
  }

  async deleteConfirmationDialog(msg: any, id?: number) {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      // call delete api
      this.deleteRecord(id);
    }
  }

  deleteRecord(id) {
    this.ngxLoaderService.start();
    try {
      if (id) {
        this.assetsService.delete(id).subscribe((res) => {
          if (res && res.success) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage('Data Deleted Successfully', 'Success', 'success');
            this.bindAssetsList();
          }
        });
      }
    } catch (e) {
      this.ngxLoaderService.stop();
      console.error(e);
    }
  }

  resetForm(): void {
    this.isFormSubmitted = false;
    this.vehicleForm.reset();
    this.driverForm.reset();
    this.vehicleOwnerForm.reset();
    this.isUpdate = false;
    // this.assetForm.get('ddlServiceCenter').reset();
  }

  getServiceCenters() {
    try {
      this.networkService.GetAllServiceCenters({ isactive: this.isUpdate ? false : true }).subscribe((res) => {
        if (res && res.success) {
          const allocatedServiceCenters = this.appCoreService.GetUserData()?.servicecenters;
          const allServiceCenters = res.data;
          this.serviceCenterList = allServiceCenters.filter(x => allocatedServiceCenters.some(y => y.id === x.id));
        }
      })
    } catch (error) {
    }
  }

  onAssetsChange() {
    const assetType = this.assetForm.get('ddlAssetType')?.value;
    // console.log("assetType", assetType)
    if (assetType == 'vehicle') {
      this.isVehicle = true;
      this.isDriver = false;
      this.isVehicleOwner = false;
      this.isActiveTab = 2;
      this.bindAssetsList();
    }
    else if (assetType == 'driver') {
      this.isVehicle = false;
      this.isDriver = true;
      this.isVehicleOwner = false;
      this.isActiveTab = 3;
      this.bindAssetsList();
    }
    else if (assetType == 'owner') {
      this.isVehicle = false;
      this.isDriver = false;
      this.isVehicleOwner = true;
      this.isActiveTab = 1;
      this.bindAssetsList();
    }
  }

  async addVehicle() {
    this.isFormSubmitted = true;
    if (this.vehicleForm.valid && this.assetForm.valid) {
      const reqObj = {
        type: this.assetForm.get('ddlAssetType').value,
        additionaldetails: {
          vehiclenumber: this.vehicleForm.get('txtVehicleNumber').value,
          vehicletype: this.vehicleForm.get('ddlVehicleType').value,
          owner: this.vehicleForm.get('ddlVehicleOwner')?.value,
          chasisnumber: this.vehicleForm.get('txtChasisNumber')?.value,
          enginenumber: this.vehicleForm.get('txtEngineNumber')?.value,
          vehiclecapacity: this.vehicleForm.get('txtVehicleCapacity')?.value,
          servicecenterid: this.assetForm.get('ddlServiceCenter')?.value,
          isactive: this.vehicleForm.get('checkBoxStatus').value ?? false
        }
      }
      this.ngxLoaderService.start()
      this.assetsService.add(reqObj).subscribe((res) => {
        try {
          if (res) {
            this.ngxLoaderService.stop()
            if (!res.success && res?.data?.err_msg) {
              this.appCoreService.showMessage(res?.data?.err_msg, 'Error', 'error');
            }
            else if (res.success) {
              this.appCoreService.showMessage('Record Added Successfully', '', 'success');
              // console.log(" res.data : ", res.data)
              this.conditionalFocus();
              this.resetForm();
            }
          }
        }
        catch (err) {
          this.ngxLoaderService.stop()
          console.error(err);
        }
      });
    }
  }

  async addDriver() {
    this.isFormSubmitted = true;
    if (this.driverForm.valid && this.assetForm.valid) {
      const reqObj = {
        type: this.assetForm.get('ddlAssetType').value,
        additionaldetails: {
          name: this.driverForm.get('txtDriverName').value,
          address1: this.driverForm.get('txtAddress1').value,
          address2: this.driverForm.get('txtAddress2').value,
          servicecenterid: this.assetForm.get('ddlServiceCenter').value,
          phoneno: this.driverForm.get('txtPhoneNo').value,
          licenceno: this.driverForm.get('txtLicenceNumber').value,
          issuedby: this.driverForm.get('txtissuedBy').value,
          issueddate: this.driverForm.get('txtIssueDate').value,
          validupto: this.driverForm.get('txtValidUpTo').value
        }
      }
      this.ngxLoaderService.start()
      this.assetsService.add(reqObj).subscribe((res) => {
        try {
          if (res) {
            this.ngxLoaderService.stop()
            if (!res.success && res?.data?.err_msg) {
              this.appCoreService.showMessage(res?.data?.err_msg, 'Error', 'error');
            }
            else if (res.success) {
              this.appCoreService.showMessage('Record Added Successfully', '', 'success');
              // console.log(" res.data : ", res.data)
              this.conditionalFocus();
              this.resetForm();
            }
          }
        }
        catch (err) {
          this.ngxLoaderService.stop()
          console.error(err);
        }
      });
    }
  }

  async addVehicleOwner() {
    this.isFormSubmitted = true;
    // console.log("vehicle :", this.vehicleOwnerForm.valid);
    // console.log("asset :", this.assetForm.valid);
    if (this.vehicleOwnerForm.valid && this.assetForm.valid) {

      const reqObj = {
        type: this.assetForm.get('ddlAssetType').value,
        additionaldetails: {
          name: this.vehicleOwnerForm.get('txtOwnerName').value,
          address1: this.vehicleOwnerForm.get('txtAddress1').value,
          servicecenterid: this.assetForm.get('ddlServiceCenter').value,
          address2: this.vehicleOwnerForm.get('txtAddress2').value,
          phoneno: this.vehicleOwnerForm.get('txtPhoneNo').value,
          pannumber: this.vehicleOwnerForm.get('txtPanNumber').value
        }
      }
      this.ngxLoaderService.start()
      this.assetsService.add(reqObj).subscribe((res) => {
        try {
          if (res) {
            this.ngxLoaderService.stop()
            if (!res.success && res?.data?.err_msg) {
              this.appCoreService.showMessage(res?.data?.err_msg, 'Error', 'error');
            }
            else if (res.success) {
              this.appCoreService.showMessage('Record Added Successfully', '', 'success');
              // console.log(" res.data : ", res.data)
              this.conditionalFocus();
              this.resetForm();
            }
          }
        }
        catch (err) {
          this.ngxLoaderService.stop()
          console.error(err);
        }
      });
    }
  }

  async updateVehicle() {
    this.isFormSubmitted = true;
    if (this.vehicleForm.valid && this.assetForm.valid) {
      const reqObj = {
        id: this.editCellId,
        type: this.assetForm.get('ddlAssetType').value,
        additionaldetails: {
          vehiclenumber: this.vehicleForm.get('txtVehicleNumber').value,
          vehicletype: this.vehicleForm.get('ddlVehicleType').value,
          owner: this.vehicleForm.get('ddlVehicleOwner').value,
          chasisnumber: this.vehicleForm.get('txtChasisNumber').value,
          enginenumber: this.vehicleForm.get('txtEngineNumber').value,
          vehiclecapacity: this.vehicleForm.get('txtVehicleCapacity').value,
          servicecenterid: this.assetForm.get('ddlServiceCenter').value,
          isactive: this.vehicleForm.get('checkBoxStatus').value
        }
      }
      this.ngxLoaderService.start();
      this.assetsService.update(reqObj).subscribe((res) => {
        try {
          if (res) {
            this.ngxLoaderService.stop();
            if (!res.success && res?.data?.err_msg) {
              this.appCoreService.showMessage(res?.data?.err_msg, 'Error', 'error');
            }
            else if (res.success) {
              this.appCoreService.showMessage('Record Updated Successfully', '', 'success');
              this.conditionalFocus();
              this.resetForm();
            }
          }
        }
        catch (err) {
          this.ngxLoaderService.stop();
          console.error(err);
        }
      });
    }
  }

  async updateDriver() {
    this.isFormSubmitted = true;
    // console.log("vehicle :", this.driverForm.valid);
    // console.log("asset :", this.assetForm.valid);
    if (this.driverForm.valid && this.assetForm.valid) {
      const reqObj = {
        id: this.editCellId,
        type: this.assetForm.get('ddlAssetType').value,
        additionaldetails: {
          name: this.driverForm.get('txtDriverName').value,
          address1: this.driverForm.get('txtAddress1').value,
          address2: this.driverForm.get('txtAddress2').value,
          servicecenterid: this.assetForm.get('ddlServiceCenter').value,
          phoneno: this.driverForm.get('txtPhoneNo').value,
          licenceno: this.driverForm.get('txtLicenceNumber').value,
          issuedby: this.driverForm.get('txtissuedBy').value,
          issueddate: this.driverForm.get('txtIssueDate').value,
          validupto: this.driverForm.get('txtValidUpTo').value
        }
      }
      // // console.log("reqObj : ", reqObj);
      this.ngxLoaderService.start();
      this.assetsService.update(reqObj).subscribe((res) => {
        try {
          if (res) {
            this.ngxLoaderService.stop();
            if (!res.success && res?.data?.err_msg) {
              this.appCoreService.showMessage(res?.data?.err_msg, 'Error', 'error');
            }
            else if (res.success) {
              this.appCoreService.showMessage('Record Updated Successfully', '', 'success');
              this.conditionalFocus();
              this.resetForm();
            }
          }
        }
        catch (err) {
          this.ngxLoaderService.stop();
          console.error(err);
        }
      });
    }
  }

  async updateVehicleOwner() {
    this.isFormSubmitted = true;
    if (this.vehicleOwnerForm.valid && this.assetForm.valid) {
      const reqObj = {
        id: this.editCellId,
        type: this.assetForm.get('ddlAssetType').value,
        additionaldetails: {
          name: this.vehicleOwnerForm.get('txtOwnerName').value,
          address1: this.vehicleOwnerForm.get('txtAddress1').value,
          servicecenterid: this.assetForm.get('ddlServiceCenter').value,
          address2: this.vehicleOwnerForm.get('txtAddress2').value,
          phoneno: this.vehicleOwnerForm.get('txtPhoneNo').value,
          pannumber: this.vehicleOwnerForm.get('txtPanNumber').value
        }
      }
      this.ngxLoaderService.start();
      this.assetsService.update(reqObj).subscribe((res) => {
        try {
          if (res) {
            this.ngxLoaderService.stop();
            if (!res.success && res?.data?.err_msg) {
              this.appCoreService.showMessage(res?.data?.err_msg, 'Error', 'error');
            }
            else if (res.success) {
              this.appCoreService.showMessage('Record Updated Successfully', '', 'success');
              this.conditionalFocus();
              this.resetForm();
            }
          }
        }
        catch (err) {
          this.ngxLoaderService.stop();
          console.error(err);
        }
      });
    }
  }

  bindAssetsList() {
    try {
      this.ngxLoaderService.start();
      this.assetsService.getAllAssets().subscribe((res: any) => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          this.combineData(res.data);
        } else {
          this.ngxLoaderService.stop();
        }
      })
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }

  combineData(data): void {
    this.combinedData = {
      driver: [],
      owner: [],
      vehicle: []
    };

    data.forEach(item => {
      const { type, servicecenter, id, additionaldetails } = item;

      const gridItem = {
        servicecenter: servicecenter || null,
        id: id || null,
        type: type || null,
        ...additionaldetails
      };

      if (type === 'driver') {
        this.combinedData.driver.push(gridItem);
      } else if (type === 'owner') {
        this.combinedData.owner.push(gridItem);
      } else if (type === 'vehicle') {
        this.combinedData.vehicle.push(gridItem);
      }
    });

    this.driverRowData = this.combinedData.driver;
    this.ownerRowData = this.combinedData.owner;
    this.vehicleRowData = this.combinedData.vehicle;
    this.ownerList = this.combinedData.owner;
  }

  editAction(cell: any) {
    try {
      if (!this.permConfig.isEditAllowed) {
        this.warningDialog('No access to Edit.');
        // console.log("not allowed");
      }
      else if (this.permConfig.isEditAllowed && cell && cell.id) {
        this.editCellId = cell.id;
        this.assetForm.get('ddlAssetType').setValue(cell.type);
        this.isUpdate = true;
        this.getServiceCenters();

        if (cell.type == 'vehicle') {
          this.isVehicle = true;
          this.isDriver = false;
          this.isVehicleOwner = false;
          this.isActiveTab = 2;

          this.assetForm.patchValue({
            ddlServiceCenter: cell.servicecenterid,
          })

          this.vehicleForm.patchValue({
            txtVehicleNumber: cell.vehiclenumber,
            ddlVehicleType: cell.vehicletype,
            ddlVehicleOwner: cell.owner,
            txtChasisNumber: cell.chasisnumber,
            txtEngineNumber: cell.enginenumber,
            txtVehicleCapacity: cell.vehiclecapacity,
            checkBoxStatus: cell.isactive,
          });
        }
        else if (cell.type == 'driver') {
          this.isVehicle = false;
          this.isDriver = true;
          this.isVehicleOwner = false;
          this.isActiveTab = 3;

          this.assetForm.patchValue({
            ddlServiceCenter: cell.servicecenterid
          })

          this.driverForm.patchValue({
            txtDriverName: cell.name,
            txtAddress1: cell.address1,
            txtAddress2: cell.address2,
            txtPhoneNo: cell.phoneno,
            txtLicenceNumber: cell.licenceno,
            txtissuedBy: cell.issuedby,
            txtIssueDate: cell.issueddate,
            txtValidUpTo: cell.validupto,
            ddlLocation: cell.location
          });
        }
        else if (cell.type == 'owner') {
          this.isVehicle = false;
          this.isDriver = false;
          this.isVehicleOwner = true;
          this.isActiveTab = 1;
          this.assetForm.patchValue({
            ddlServiceCenter: cell.servicecenterid
          })

          this.vehicleOwnerForm.patchValue({
            txtOwnerName: cell.name,
            txtAddress1: cell.address1,
            txtAddress2: cell.address2,
            txtPhoneNo: cell.phoneno,
            txtPanNumber: cell.pannumber,
            ddlLocation: cell.location,
          });
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  formateDate(date?: any) {
    const inputDate = date != null || undefined ? new Date(date) : new Date();
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, '0');
    const day = inputDate.getDate().toString().padStart(2, '0');
    const dateString = `${day}-${month}-${year}`;
    return { dateString };
  }
  
  warningDialog(msg: any) {
    Swal.fire({
      title: 'Warning!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
  }

  conditionalFocus() {
    (this.isVehicle ? this.vehicleCode.nativeElement 
     : this.isDriver ? this.driverName.nativeElement 
     : this.ownerName.nativeElement).focus();
  }
}